import { makeAutoObservable } from "mobx";
import { TasksStore } from "./TasksStore";
import { ModuleStore } from "./ModuleStore";
import { ModuleResourceStore } from "./ModuleResourceStore";
import { ModuleResourceRowDTO } from "../../ProfileWindow/AdminWindows/ModuleEditWindow/DTO/ModuleResourceRowDTO";
import { ResourceResponseApi } from "../../DTO/ServerResponseType/Resource/Resource";
import { TaskWithContent } from "../../DTO/ServerResponseType/Task/Task";
import { ResourcesStore } from "./ResourcesStore";

export class ModuleWindowStore {
  showAddedRow: boolean = false;
  showDeleteModalToDeleteModuleResource: boolean = false;
  tasksStore: TasksStore;
  resourcesStore: ResourcesStore;
  moduleStore: ModuleStore;
  addModuleResourceStore: ModuleResourceStore;
  moduleResourceToDelete: ModuleResourceRowDTO;

  constructor() {
    this.tasksStore = new TasksStore();
    this.resourcesStore = new ResourcesStore();
    this.moduleStore = new ModuleStore();
    this.addModuleResourceStore = new ModuleResourceStore();
    this.moduleResourceToDelete = new ModuleResourceRowDTO();
    makeAutoObservable(this);
  }

  onChangeSelectResource = (event: React.FormEvent<HTMLSelectElement>) => {
    let selectedResourceAttribute = event.currentTarget.options[
      event.currentTarget.selectedIndex
    ].getAttribute("data-resource-or-task");

    let resourceOrTask: ResourceResponseApi | TaskWithContent | undefined;

    if (selectedResourceAttribute === "resource")
      resourceOrTask = this.resourcesStore.selectedResource(event);
    else if (selectedResourceAttribute === "task")
      resourceOrTask = this.tasksStore.selectedTask(event);

    this.addModuleResourceStore.setModuleResource(resourceOrTask);
    this.onChangeSelectResourceType(
      this.addModuleResourceStore.moduleResource.typeId
    );
  };

  onChangeSelectResourceType = (
    eventOrType: React.FormEvent<HTMLSelectElement> | number
  ) => {
    this.tasksStore.onChangeFilterType(eventOrType);
    this.resourcesStore.onChangeFilterType(eventOrType);
    this.addModuleResourceStore.onChangeType(eventOrType);
  };

  addModuleResourceAsync = async (moduleResource: ModuleResourceRowDTO) => {
    try {
      this.moduleStore.moduleResourcesStore.addResource(moduleResource);
      this.addModuleResourceStore.moduleResource.clear();
      this.onChangeSelectResourceType(-1);
      this.onAddedRowClose();
    } catch (e) {
      alert("Выберите ресурс");
    }
  };

  deleteModuleResource = (moduleResource: ModuleResourceRowDTO) => {
    try {
      this.moduleStore.moduleResourcesStore.deleteModuleResource(
        moduleResource
      );
      this.moduleResourceToDelete.clear();
      this.onDeleteModalClose();
    } catch (e) {
      alert("Возникла ошибка при удалении");
    }
  };

  onDeleteModalOpen = (moduleResourceData: ModuleResourceRowDTO) => {
    this.showDeleteModalToDeleteModuleResource = true;
    this.moduleResourceToDelete = moduleResourceData;
  };

  onDeleteModalClose = () => {
    this.showDeleteModalToDeleteModuleResource = false;
  };

  onAddedRowShow = () => {
    this.showAddedRow = true;
  };

  onAddedRowClose = () => {
    this.showAddedRow = false;
  };
}
